import './styles/App.css';

import {Element, animateScroll} from 'react-scroll';
import {Fade} from 'react-awesome-reveal';

// components
import Home from './Components/Home';

// icon
import {CgArrowLongUp} from 'react-icons/cg';

function App() {
    return (
        <div className='App'>
            <Element name="intro" className="element">
                <div>
                    <Home/>
                </div>
            </Element>
        </div>
    );
}

export default App;